module.exports = __webpack_public_path__ + "img/ratenkauf.49b81be6.png";